// ABOUTME: The Make It Right task as Kuleana shows it, read-only, for Hold: title, frequency chip, progress and the items.
// ABOUTME: Styled from the chore list card with the Crossing tokens (the runner sits under the Crossing theme); nothing on it can be toggled.

import { Box, Checkbox, Chip, LinearProgress, Typography } from '@mui/material';
import type { ChoreListPeriodStatus } from '../../../../types/api';
import { normalizeRepeatFrequency } from '../../../../utils/choreListUtils';
import {
  CROSSING_CORAL, CROSSING_CORAL_SOFT, CROSSING_HAIRLINE, CROSSING_HEADLINE_INK, CROSSING_SUB_INK,
} from '../../../../theme/crossingTokens';

interface MakeItRightTaskTileProps {
  list: ChoreListPeriodStatus;
}

export default function MakeItRightTaskTile({ list }: MakeItRightTaskTileProps) {
  const percent = list.totalItems > 0 ? Math.round((list.completedItems / list.totalItems) * 100) : 0;

  return (
    <Box
      data-testid="make-it-right-task-tile"
      sx={{
        width: '100%', boxSizing: 'border-box', p: 1.5, textAlign: 'left',
        border: `1px solid ${CROSSING_HAIRLINE}`, borderLeft: `4px solid ${CROSSING_CORAL}`, borderRadius: '14px',
        backgroundColor: CROSSING_CORAL_SOFT, color: CROSSING_HEADLINE_INK,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1, mb: 0.75 }}>
        <Typography component="h3" sx={{ fontFamily: 'Newsreader, serif', fontSize: '17px', fontWeight: 600, lineHeight: 1.25 }}>
          {list.title}
        </Typography>
        <Chip label={normalizeRepeatFrequency(list.repeatFrequency)} size="small" variant="outlined" sx={{ height: 22, fontSize: '0.72rem', color: CROSSING_HEADLINE_INK }} />
      </Box>
      <LinearProgress
        variant="determinate"
        value={percent}
        aria-label={list.title}
        sx={{ height: 6, borderRadius: 3, mb: 0.5, backgroundColor: CROSSING_HAIRLINE, '& .MuiLinearProgress-bar': { backgroundColor: CROSSING_CORAL } }}
      />
      <Typography sx={{ fontSize: '12px', fontWeight: 600, color: CROSSING_SUB_INK, mb: 0.5 }}>
        {list.completedItems} of {list.totalItems} complete
      </Typography>
      <Box component="ul" sx={{ listStyle: 'none', m: 0, p: 0 }}>
        {list.items.map(item => (
          <Box component="li" key={item.id} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            {/* Shown as it stands in Kuleana, not a control here: out of the tab order and read-only. */}
            <Checkbox
              checked={item.isCompleted}
              size="small"
              disableRipple
              readOnly
              slotProps={{ input: { 'aria-label': item.title, 'aria-readonly': true, tabIndex: -1 } }}
              sx={{ p: 0.5, color: CROSSING_CORAL, '&.Mui-checked': { color: CROSSING_CORAL }, pointerEvents: 'none' }}
            />
            <Typography sx={{ fontSize: '14px', lineHeight: 1.35 }}>{item.title}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
